import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  padding-top: 90px;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e3e4e6;

  ${mediaMaxWidth.phone} {
    padding-top: 70px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 600px;
  min-height: 600px;
  margin-bottom: 100px;
  align-items: center;

  .fade-appear {
    position: absolute;
    top: 130px;
    left: 0;
    right: 0;
    margin: 0 auto;
    opacity: 0;
    z-index: 1;

    &.fade-appear-active {
      position: absolute;
      top: 110px;
      opacity: 1;
      transition: all 300ms ease-in-out 200ms;
    }
  }

  .fade-enter {
    opacity: 0;
    z-index: 1;
    left: 1000px;
    position: absolute;

    &.fade-enter-active {
      opacity: 1;
      transition: all 400ms ease-in-out;
      left: 0;
      position: absolute;
    }
  }

  .fade-exit {
    opacity: 1;
    position: absolute;

    &.fade-exit-active {
      opacity: 0;
      transition: all 400ms ease-in-out;
      left: -1000px;
      position: absolute;
    }

    &.fade-exit-done {
      opacity: 0;
      left: -1000px;
      position: absolute;
    }
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 20px);
  }
`;

interface IStepWrapperProps {
  description?: boolean;
  formStep?: boolean;
  thankYou?: boolean;
}

export const StepWrapper = styled.div`
  display: flex;
  width: ${(props: IStepWrapperProps) => (props.formStep ? "400px" : "600px")};
  flex-direction: column;
  min-height: 600px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;

  form {
    display: flex;
    flex-direction: column;
  }

  ${mediaMaxWidth.tablet} {
    width: ${(props: IStepWrapperProps) => props.description && "480px"};
    width: ${(props: IStepWrapperProps) => props.thankYou && "480px"};
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 20px);
  }
`;

export const Title = styled.h2`
  display: flex;
  justify-content: center;
  color: #402680;
  margin: 10px 0 15px 0;
  font-size: 1.6em;

  ${mediaMaxWidth.phone} {
    font-size: 1.4em;
    margin: 5px 0 10px 0;
  }
`;

interface IParagraphProps {
  first?: boolean;
  last?: boolean;
  centered?: boolean;
}

export const Paragraph = styled.p`
  color: #402680;
  margin: 15px 0;
  margin: ${(props: IParagraphProps) => props.first && "25px 0 15px 0"};
  margin: ${(props: IParagraphProps) => props.last && "15px 0 50px 0"};
  line-height: 1.45em;
  font-size: 1.1em;
  text-align: ${(props: IParagraphProps) => props.centered && "center"};

  ${mediaMaxWidth.phone} {
    font-size: 1.05em;
  }
`;

export const Spinner = styled.img``;

interface IReCaptchaContainerProps {
  disabled: boolean;
}

export const ReCaptchaContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 25px 0;
  align-items: center;
  position: relative;
  transition: 0.1s ease-in-out;
  filter: ${(props: IReCaptchaContainerProps) =>
    props.disabled ? "opacity(0.4) grayscale(1)" : "none"};
  pointer-events: ${(props: IReCaptchaContainerProps) =>
    props.disabled && "none"};
`;

export const ReCaptchaError = styled.div`
  text-align: center;
  position: absolute;
  bottom: -15px;
  font-size: 0.82em;
  color: #79D9D9;
  font-weight: 600;
`;

export const DisabledButton = styled.button`
  position: relative;
  margin: 0 auto;
  justify-content: center;
  font-weight: bold;
  color: #fff;
  background-color: #ababab;
  border: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 22px;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  padding: 10px 12px;
  font-family: Komet;
  letter-spacing: 0.03em;
  text-transform: capitalize;
  font-size: 1em;
  min-width: 100px;
  min-height: 44px;
  cursor: not-allowed;
  transition: 0.1s ease-in-out;
  outline: 2px solid transparent;

  ${Spinner} {
    width: 26px;
    position: absolute;
    top: 8px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
`;

export const Button = styled.button`
  margin: 0 auto;
  justify-content: center;
  font-weight: bold;
  color: #fff;
  background-color: #79D9D9;
  border: 1px solid #79D9D9;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 22px;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  padding: 10px 12px;
  font-family: Komet;
  letter-spacing: 0.03em;
  text-transform: capitalize;
  font-size: 1em;
  min-width: 100px;
  transition: 0.1s ease-in-out;
  outline: 2px solid transparent;

  &:hover {
    cursor: pointer;
    color: #fff;
    background-color: #79D9D9;
    border: 1px solid #79D9D9;
  }

  &:active,
  &:visited {
    cursor: pointer;
    color: #fff;
    background: #402680;
    border: 1px solid #402680;
    outline-color: #402680;
  }

  &:focus {
    background-color: #79D9D9;
    border: 1px solid #402680;
    outline: 2px solid #8064d4;
  }
`;
